module.exports = __webpack_public_path__ + "img/color-get-cash.5206b346.svg";